module.exports = __webpack_public_path__ + "static/media/cross-black-light.fa281ea7.svg";